// Copyright (c) Docugami, Inc. All rights reserved.

import { Spinner, SpinnerSize } from '@fluentui/react';
import styled from 'styled-components';

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    min-height: 200px;
`;

/**
 * Loading fallback component for React.lazy() code-split pages
 */
export const PageLoadingFallback = (): JSX.Element => {
    return (
        <LoadingContainer>
            <Spinner size={SpinnerSize.large} label="Loading..." />
        </LoadingContainer>
    );
};
